

Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.FieldsMappingTable = (function () {

    function FieldsMappingTable(preview, fileType) {

        App.Forms.DataImport = App.Forms.DataImport || {};
        App.Forms.DataImport.FieldsMappingTable = this;

        var lines = preview.header,
            render = new Greenmile.DataImport.FieldsRender(this);

        this.layout = null;
        this.previewData = {};
        this.csvFieldList = {};
        this.gmFieldList = {};

        this.fillLineFunction = null;

        var csv = [
            {type: 'LABEL', value: Monet.I18n.getResourcesByKey('Greenmile.DataImport.gmfield')},
            {type: 'LABEL', value: Monet.I18n.getResourcesByKey('Greenmile.DataImport.fixed')},
            {type: 'LABEL', value: Monet.I18n.getResourcesByKey('Greenmile.DataImport.upper')},
            {type: 'LABEL', value: Monet.I18n.getResourcesByKey('Greenmile.DataImport.lower')},
            {type: 'LABEL', value: Monet.I18n.getResourcesByKey('Greenmile.DataImport.prepend')},
            {type: 'LABEL', value: Monet.I18n.getResourcesByKey('Greenmile.DataImport.append')},
            {type: 'LABEL', value: Monet.I18n.getResourcesByKey('Greenmile.DataImport.format')}
        ];

        this.getMandatoryFields = function (callback) {
            var ajax = new Monet.Ajax(),
                entity = App.Forms.DataImport.EntityList.getSelected();

            var importType = App.Forms.DataImport.MappingTemplate.getTypeImportSelected();
            ajax.url = "TextFileMetadata/mandatory/field/" + entity + '/?importType=' + importType;
            ajax.method = "GET";
            ajax.success = callback;
            ajax.send();
        };

        if(fileType.toUpperCase() === 'CSV') {

            csv.unshift({type: 'LABEL', value: Monet.I18n.getResourcesByKey('Greenmile.DataImport.csvfield')});

            for(var i =0; i < lines.length; i++) {

                if(!App.Forms.DataImport.CSVConfigurations.checks.hasHeader.field.value) {
                    lines[i].value = parseInt(lines[i].value) + 1;
                }

                var columnValue = lines[i].value;
                this.csvFieldList[columnValue] = {
                    label: columnValue,
                    path: columnValue,
                    type: 'TEXT',
                    fileColumnNum: lines[i].fileColumnNum
                };

                this.previewData[columnValue] = preview.firstLine[i];
            }


        } else {
            this.previewData = preview.firstLine[0][0];
            csv.unshift({type: 'LABEL', value: Monet.I18n.getResourcesByKey('Greenmile.DataImport.file')});
        }

        this.createBaseStructure = function() {

            this.tableContainer = document.createElement('div');
            this.btnNewLine = document.createElement('div');
            this.table = document.createElement('table');

            this.table.className = 'tablePreview';
            this.tableContainer.className = 'tablecontent';
            this.btnNewLine.className = 'btnNewLine';
            this.btnNewLine.setAttribute('title', Monet.I18n.getResourcesByKey('Greenmile.DataImport.addNewLine'));

            this.table.appendChild(this.getLine(csv, 'csv'));

            this.tableContainer.appendChild(this.table);
            this.tableContainer.appendChild(this.btnNewLine);

            this.selectFieldCsv = new Greenmile.DataImport.SelectFieldList(this.csvFieldList, 'csv-field-list');
            this.selectFieldCsv.addClickEventListener(this.setSelectedValue);

            this.tableContainer.appendChild(this.selectFieldCsv.render());

            var length = lines.length-1;
            this.btnNewLine.addEventListener('click', function() {
                var cell = lines[length];
                this.addNewLine(cell,  this.previewData[lines[length]], length);
            }.bind(this));

        }.bind(this);

        //Chamado quando clica na celula da tabela para abrir o picklist
        this.btnClickListener = function(e, element) {

            e.stopPropagation();
            e.preventDefault();

            var fieldTypeClass = '.'+ element.getAttribute('cell-type') + '-field-list' ;
            var fieldList = this.tableContainer.querySelector(fieldTypeClass + ' .btn-group.bootstrap-select.pickListFieldFilters.fieldList'),
                selectpicker = $('.tablecontent '+ fieldTypeClass+' select.pickListFieldFilters'),
                targetPosition = element.getClientRects()[0],
                select = this.selectFieldCsv;

            if ( fieldTypeClass.indexOf('gm') !== -1 ) {
                select = this.selectFieldGM;
            }

            select.setElementShowList(element);
            selectpicker.selectpicker('refresh');
            selectpicker.selectpicker('show');

            $(this.tableContainer.querySelector(fieldTypeClass + ' .btn.dropdown-toggle.btn-default')).trigger("click");

            fieldList.style.left = (targetPosition.left - 5) + 'px';
            fieldList.style.top = (targetPosition.top + 1) + 'px';

        }.bind(this);

        //Get cell content by type
        this.getFieldByType = function(cell) {
           return render.getFieldByType(cell);
        }.bind(this);

        this.getLine = function(cells, className) {

            var line = document.createElement('tr'),
                cell, obj;

            line.className = 'line ' + className;

            for (var i = 0, length = cells.length; i < length; i++) {

                cell = document.createElement('th');
                cell.className = 'cell '+ (cells[i].className || '');
                cell.setAttribute('line', i);

                if(cells[i].type === 'LABEL') {
                    cell.innerHTML = cells[i].value;
                } else {
                    obj = this.getFieldByType(cells[i]);

                    cell.appendChild(obj.rootEl);

                    if(cells[i].type === 'FIELD') {
                        this.setSelectedValue(cells[i], obj.rootEl.querySelector('span.value'));
                    }
                }

                line.appendChild(cell);
            }

            cell = document.createElement('th');
            var remove = document.createElement('div');
            cell.className = 'cell remove';
            remove.className = 'gmfont icon-remove';
            cell.appendChild(remove);
            cell.setAttribute('title', Monet.I18n.getResourcesByKey('Greenmile.Survey.Menu.delete'));
            if(className !== 'csv') {
                remove.addEventListener('click', this.removeLine);
            }

            line.appendChild(cell);

            return line;
        };

        this.removeLine = function(e) {
            var line = e.target.parentElement.parentElement;
            line.parentNode.removeChild(line);

        }.bind(this);

        this.setSelectedValue = function(value, element) {

            var cell = element.parentElement.parentElement.parentElement;
            this.setSelectedValueOnFieldCell(value, element, cell);

        }.bind(this);

        this.setSelectedValueOnFieldCell = function(value, element, cell) {

            var label = '',
                preview = cell.querySelector('.preview');
            if(value) {
                cell.setAttribute('path', value.path || '');
                if(value.fileColumnNum ) {
                    cell.setAttribute('fileColumnNum', value.fileColumnNum);
                }
                label = value.label || '';
                preview.innerHTML = this.previewData[label] || '';
            } else {
                cell.removeAttribute('path');
                preview.innerHTML = '';
            }
            element.innerHTML = Monet.I18n.getResourcesByKey(label);
            element.setAttribute('title', Monet.I18n.getResourcesByKey(label) );

        };

        this.setValuesOnListCell = function(listInfo, cell, fieldData) {

            if ( cell ) {

                cell.innerHTML = '';
                var data = null;
                var input = null,
                    fieldDomains = (listInfo.options ? listInfo.options.fieldDomains : null),
                    type = (fieldData && fieldData.typeToFormat ? fieldData.typeToFormat : 'TEXT');

                if ( fieldDomains && fieldDomains.length && cell) {
                    data = this.getFieldByType({ type: 'LIST', fieldDomains: fieldDomains, editable : listInfo.editable, value: fieldData.value });

                    data.componentValue.setValue(listInfo.options.defaultValue);

                    input = data.componentValue.inputValue;
                    cell.appendChild(data.rootEl);

                } else {
                    data = this.getFieldByType({ type: type, value: fieldData.value });
                    input = data.componentValue;
                    cell.appendChild( data.rootEl );
                }

                if(input) {

                    input.addEventListener('blur', function(e) {
                        var value = e.target.value;
                        if( !value ) {
                            e.target.removeAttribute('valueToSend');
                        } else {
                            value = render.getFieldValue(e.target);
                            e.target.setAttribute('valueToSend', value);
                        }
                    });
                }
            }

        }.bind(this);

        this.disableCellsByType = function(fieldData, cell) {

            var line = cell.parentNode;

            if(fieldData.type !== 'STRING') {

                line.querySelector('.prepend-cell input').setAttribute('disabled', 'true');
                line.querySelector('.append-cell input').setAttribute('disabled', 'true');
                line.querySelector('.upper-cell input').setAttribute('disabled', 'true');
                line.querySelector('.lower-cell input').setAttribute('disabled', 'true');
            }
        };

        this.selectGMFieldValue = function(value, element) {

            this.setSelectedValue(value, element);

            var cell = element.parentElement.parentElement.parentElement;
            var getCell = function(selector) {
                if(cell.parentElement ){
                    return cell.parentElement.querySelector(selector);
                }
            }.bind(this);

            var getFieldDomainsFixedValues = function(listType) {
                var fieldDomains = [];
                if(value && this.gmFieldList[value.path] ) {
                    fieldDomains = this.gmFieldList[value.path][listType];
                }

                return {
                    options: fieldDomains,
                    editable: false
                };

            }.bind(this);

            var getFieldDomainsToFormatters = function() {

                var fieldDomains = [];

                if(value) {
                    fieldDomains = Greenmile.DataImport.Utils.getFormatterOptionsByType(value.type);
                    if(fieldDomains) {
                        fieldDomains.defaultValue = value.format || fieldDomains.defaultValue;
                    }

                }
                return {
                    options: fieldDomains,
                    editable: true
                };

            }.bind(this);

            value.typeToFormat = value.type;

            value.value = value.defaultValue;
            this.setValuesOnListCell( getFieldDomainsFixedValues('values'), getCell('.fixed-cell'), value);

            value.value = value.format;

            if(value.type === 'BOOLEAN') {
                value.typeToFormat = 'STRING';
            }
            this.setValuesOnListCell( getFieldDomainsToFormatters(), getCell('.cell.format-cell'), value);

            this.disableCellsByType(value, cell);

        }.bind(this);

        this.getRootEntityFields = function(callback) {
            var entitySelected = App.Forms.DataImport.EntityList.getSelected();
            var request = new Monet.Ajax();

            request.url = 'Metadata/Field/'+ entitySelected;
            request.method = 'GET';
            request.error = (error) => {
              return Greenmile.DataImport.Utils.showErrorMessage(error.responseText);
            };
            request.success = function (data) {

                if(data) {
                    this.gmFieldList = {};
                    for(var i = 0, length = data.length; i < length; i++) {
                        if (Monet.I18n.getResourcesByKey(data[i].label) !== data[i].label) {
                            this.gmFieldList[data[i].path] = data[i];
                        }
                    }

                    this.selectFieldGM = new Greenmile.DataImport.SelectFieldList(this.gmFieldList, 'gm-field-list');
                    this.selectFieldGM.addClickEventListener(this.selectGMFieldValue);

                    this.tableContainer.appendChild(this.selectFieldGM.render());

                    if(callback) {
                        callback(data);
                    }
                }


            }.bind(this);

            request.send();

        };

        this.getFixedValuesByLine = function(line) {

            var fixedField = line.querySelector('.fixed-cell').childNodes[0],
                gmFieldPath = line.querySelector('.gm').getAttribute('path') || undefined,
                objToReturn = {},
                fixedValue = fixedField.getAttribute('valueToSend') || undefined;

            objToReturn.fieldPath = gmFieldPath || undefined;
            objToReturn.defaultValue = fixedValue || render.getFieldValue(fixedField) || undefined;

            objToReturn.prepend = line.querySelector('.prepend-cell input').value || undefined;
            objToReturn.append = line.querySelector('.append-cell input').value || undefined;
            objToReturn.upper = line.querySelector('.upper-cell input').checked;
            objToReturn.lower = line.querySelector('.lower-cell input').checked;
            objToReturn.format = line.querySelector('.format-cell input').value || undefined;

            return objToReturn;
        };

        this.setFixedColumnsValue = function(line, model) {

            line.querySelector('.prepend-cell input').value = model.prepend || '';
            line.querySelector('.append-cell input').value = model.append || '';
            line.querySelector('.upper-cell input').checked = model.upper;
            line.querySelector('.lower-cell input').checked = model.lower;
        };

        this.setColumnsValue = function(layout) {

            this.layout = layout;

            if(!layout || !Object.keys(this.gmFieldList).length) {
                return;
            }

            this.fillLineFunction();


        }.bind(this);

        this.getFixedColumns = function() {

            return  [
                {type: 'FIELD', fieldList: this.gmFieldList, className:'gm'},
                {type: 'TEXT', className:'fixed-cell'},
                {type: 'CHECK', className:'upper-cell'},
                {type: 'CHECK', className:'lower-cell'},
                {type: 'TEXT', className:'prepend-cell'},
                {type: 'TEXT', className:'append-cell'},
                {type: 'TEXT', className:'format-cell'}
            ];
        };

        this.addNewLine = function(value, preview, offset, length) {
            var columns = this.getFixedColumns();

            if ( fileType.toUpperCase() === 'CSV' ) {
                value.type = 'FIELD';
                value.className = 'csv';
                value.label = value.value;
                columns.unshift(value);
            } else {
                columns.unshift({type: 'RANGE', values: [offset, length]});
            }

            var line = this.getLine(columns, 'info');
            this.table.appendChild(line);

            return line;

        }.bind(this);

        this.mountTable = function(value) {
            if (!value) {
                this.getMandatoryFields(function(data) {
                    for (var i = 0, length = data.length; i < length; i++) {
                        var line = this.addNewLine({});
                        this.selectGMFieldValue(data[i], line.querySelector('.gm  span.value'));
                    }
                }.bind(this));
            }
        }.bind(this);

        this.render = function(value) {

            this.createBaseStructure();

            var scope = this;
            this.getRootEntityFields(function(){
                if(value) {
                    for (var i = 0, length = value.columns.length; i < length; i++) {
                        var data = value.columns[i],
                            fileColumnName = data.fileColumnName,
                            model = this.gmFieldList[data.fieldPath],
                            columnNum = (this.csvFieldList[fileColumnName] ? this.csvFieldList[fileColumnName].fileColumnNum : null);
                            fileColumnName = (this.csvFieldList[fileColumnName] ? this.csvFieldList[fileColumnName].label : '');

                        var line =this.addNewLine({
                            fileColumnNum: columnNum,
                            path: fileColumnName,
                            value : fileColumnName
                        }, this.previewData[fileColumnName]);

                        model.defaultValue = data.defaultValue;
                        model.format = data.format;
                        this.selectGMFieldValue(model, line.querySelector('.gm  span.value'));

                    }
                    this.setColumnsValue(this.layout);
                }
            }.bind(scope));
            this.mountTable(value);

            return this.tableContainer;
        };
    }

    return FieldsMappingTable;

}());
